import React, { useEffect } from 'react';
export const HowWeHelpPage = () => {
  useEffect(() => {
    document.title = 'How We Help | Race Capital';
  }, []);
  const gtmPillars = [{
    title: 'Go-To-Market Buildout',
    points: ['Define ICP and sales motion', 'Build CRM structure and pipeline discipline', 'Weekly deal reviews and forecast roll-ups', 'Goal: clear visibility, healthy velocity, repeatability']
  }, {
    title: 'Sales Execution & Discipline',
    points: ['Weekly revenue rollup led by Matt McLaughlin (Head of Sales)', 'Real prospect intros and guided POCs', 'Contract coaching to reduce churn risk', 'Track conversion, expansion, deal size']
  }, {
    title: 'Customer Pipeline Development',
    points: ['Warm intros to qualified enterprise buyers', 'Founder sales call coaching and debrief', 'Build early ARR, reference customers, and Series A proof points']
  }, {
    title: 'Hiring the First Sales Team',
    points: ['Help design comp plans and interview AEs', 'Backchannel references on every candidate', 'Coach founders to manage sales talent', 'Target: AE productivity in 90 days, not 9 months']
  }, {
    title: 'Pricing & Contract Strategy',
    points: ['Move from usage-based to predictable annual contracts', 'Build standard MSA and security review playbooks', 'Enable multi-year, enterprise-grade deals']
  }, {
    title: 'Strategic Support',
    points: ['Active lead investors, not quarterly observers', 'Milestone tracking, follow-on narrative shaping', 'Weekly or biweekly engagement for real accountability']
  }];
  const whyRace = [{
    title: "We've been in your seat",
    description: 'Founded, operated, scaled - we know what it actually takes'
  }, {
    title: "Your interest first, even when it's hard",
    description: 'Honest conversations, not cheerleading'
  }, {
    title: 'Close, not performative',
    description: 'Real availability, not quarterly check-ins. We will roll our sleeves when you need our help'
  }, {
    title: 'GTM help that actually lands',
    description: 'Customers, deals, hires - not just intros, real closes'
  }];
  return <div className="w-full bg-white mt-20" data-id="element-263" data-mp="3fzxq1aj8cbsw">
      {/* Hero Section */}
      <section className="w-full pt-20 pb-20 px-6 md:px-12 bg-gradient-to-b from-white to-gray-50/50" data-id="element-264" data-mp="3b7ehwt3ba8vh">
        <div className="max-w-7xl mx-auto" data-id="element-265" data-mp="369mofun0qep6">
          <div className="relative mb-6 overflow-visible" data-id="element-266" data-mp="366guo23g2on4">
            <style jsx data-id="element-267" data-mp="31at8zwo68dmd">{`
              @keyframes fillFromLeft {
                from {
                  transform: scaleX(0);
                  transform-origin: left;
                }
                to {
                  transform: scaleX(1);
                  transform-origin: left;
                }
              }
              .racing-stripe {
                transform: scaleX(0);
                transform-origin: left;
                animation: fillFromLeft 0.8s ease-out forwards;
              }
              .racing-stripe:nth-child(1) {
                animation-delay: 0.1s;
              }
              .racing-stripe:nth-child(2) {
                animation-delay: 0.2s;
              }
              .racing-stripe:nth-child(3) {
                animation-delay: 0.3s;
              }
              .racing-stripe:nth-child(4) {
                animation-delay: 0.4s;
              }
            `}</style>
            <div className="absolute right-[12px] top-0 hidden md:flex flex-col space-y-2 pointer-events-none" data-id="element-268" data-mp="xyvcawg8zc9e">
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/30 to-red-600/10" style={{
              width: '240px',
              marginLeft: '0px'
            }} data-id="element-269" data-mp="12thkyruy2qps"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/35 to-red-600/15" style={{
              width: '200px',
              marginLeft: '40px'
            }} data-id="element-270" data-mp="2c1kuo6zjqmto"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/40 to-red-600/20" style={{
              width: '160px',
              marginLeft: '80px'
            }} data-id="element-271" data-mp="2gzmgv0s9r29d"></div>
              <div className="racing-stripe h-1.5 bg-gradient-to-r from-red-600/45 to-red-600/25" style={{
              width: '120px',
              marginLeft: '120px'
            }} data-id="element-272" data-mp="2qontqi3ip3j4"></div>
            </div>
            <h1 className="relative z-10 text-[clamp(2.5rem,5vw,4rem)] font-semibold text-[#070707] tracking-tight leading-[1.15]" data-id="element-273" data-mp="1aanwjew23rzk">
              How We Help
            </h1>
          </div>
          <p className="text-lg text-gray-600 max-w-3xl leading-relaxed font-light" data-id="element-274" data-mp="3gzpzmfqax5kn">
            We operate as active co-builders to help enterprise infrastructure
            startups go from $0 to $10M+ ARR with disciplined go-to-market
            systems, real customer pipelines, and founder-ready sales support.
          </p>
        </div>
      </section>
      {/* Core GTM Pillars */}
      <section className="w-full py-20 px-6 md:px-12 bg-white" data-id="element-275" data-mp="2y8yhaooc64u4">
        <div className="max-w-7xl mx-auto" data-id="element-276" data-mp="2y7ncclj5mr1f">
          <div className="mb-16" data-id="element-277" data-mp="337rsgag5hjr4">
            <h2 className="text-4xl md:text-5xl font-bold text-[#070707] mb-4 tracking-tight" data-id="element-278" data-mp="338ujqjhdxo7k">
              Core GTM Pillars
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl leading-relaxed font-light" data-id="element-279" data-mp="2pamqaljk5515">
              Our six-part structure for building repeatable, scalable revenue.
            </p>
          </div>
          <div className="bg-white border border-gray-100 rounded-3xl overflow-hidden shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-id="element-280" data-mp="nf2qar6sxyyi">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3" data-id="element-281" data-mp="20fytxhzmseza">
              {gtmPillars.map((pillar, index) => <div key={index} className="p-10 border-b md:border-r border-gray-100 last:border-b-0 md:last:border-r-0 lg:[&:nth-child(3n)]:border-r-0 hover:bg-gray-50/50 transition-all relative group" data-id="element-282" data-mp="1vfkx6w3hcrgk" data-mpi={index}>
                  <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-red-600 transform scale-y-0 group-hover:scale-y-100 transition-all origin-top" data-id="element-283" data-mp="2j5oy2vpaad3v"></div>
                  <div className="text-5xl font-light text-red-600/20 group-hover:text-red-600 transition-colors mb-6" data-id="element-284" data-mp="2f550xs4pn9hq">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <h3 className="text-xl font-semibold text-[#070707] mb-6 group-hover:text-red-600 transition-colors" data-id="element-285" data-mp="25ea5bx5kqxjm">
                    {pillar.title}
                  </h3>
                  <ul className="space-y-3" data-id="element-286" data-mp="2y2fr8n8d6sl1">
                    {pillar.points.map((point, pointIndex) => <li key={pointIndex} className="text-gray-600 text-sm flex items-start" data-id="element-287" data-mp="35fx5j6101hy9" data-mpi={pointIndex}>
                        <span className="text-red-600 mr-3 mt-0.5" data-id="element-288" data-mp="3fca3wh7hojzc">✓</span>
                        {point}
                      </li>)}
                  </ul>
                </div>)}
            </div>
          </div>
        </div>
      </section>
      {/* Why Founders Choose Race */}
      <section className="w-full py-20 px-6 md:px-12 bg-gradient-to-b from-gray-50/50 to-white" data-id="element-289" data-mp="3tb0445pluzrx">
        <div className="max-w-7xl mx-auto" data-id="element-290" data-mp="1yye2av8ar9r">
          <h2 className="text-4xl font-bold text-[#070707] mb-16 tracking-tight" data-id="element-291" data-mp="1zzs8o7jjtvp">
            Why Founders Choose Race
          </h2>
          <div className="bg-white border border-gray-100 rounded-3xl overflow-hidden shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-id="element-292" data-mp="az39dmn5dz7k">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4" data-id="element-293" data-mp="fy6hjfyfcljr">
              {whyRace.map((reason, index) => <div key={index} className="p-10 border-b md:border-r border-gray-100 last:border-b-0 md:last:border-r-0 lg:[&:nth-child(4n)]:border-r-0 hover:bg-gray-50/50 transition-all relative group" data-id="element-294" data-mp="11ag2l7isuboh" data-mpi={index}>
                  <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-red-600 transform scale-y-0 group-hover:scale-y-100 transition-all origin-top" data-id="element-295" data-mp="168hmfuo1uf10"></div>
                  <div className="flex items-start mb-4" data-id="element-296" data-mp="dislfhbcaeze">
                    <span className="text-red-600 mr-3 mt-0.5 text-xl flex-shrink-0" data-id="element-297" data-mp="dkc0x5p68m04">
                      ✓
                    </span>
                    <h3 className="text-lg text-gray-900 group-hover:text-red-600 font-semibold transition-colors" data-id="element-298" data-mp="ngyldtdl5b1m">
                      {reason.title}
                    </h3>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed pl-8" data-id="element-299" data-mp="3qxotcdsq9y5y">
                    {reason.description}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </section>
      {/* GTM Blog Link */}
      <section className="w-full py-20 px-6 md:px-12 bg-white" data-id="element-300" data-mp="2b7nwlr952q1s">
        <div className="max-w-7xl mx-auto" data-id="element-301" data-mp="1wi8c2t07bguj">
          <div className="bg-gradient-to-br from-white to-gray-50 rounded-3xl p-10 md:p-16 border border-gray-200 shadow-xl" data-id="element-302" data-mp="1wfdq2x1jhnz0">
            <div className="flex flex-col md:flex-row items-center justify-between" data-id="element-303" data-mp="2p6dv9bblwxs9">
              <div className="mb-8 md:mb-0 md:mr-12" data-id="element-304" data-mp="2p4b3alqw8ukw">
                <h2 className="text-3xl font-bold text-[#070707] mb-4 tracking-tight" data-id="element-305" data-mp="2u3w83csqvx5j">
                  Learn More About Our GTM Approach
                </h2>
                <p className="text-lg text-gray-600 leading-relaxed" data-id="element-306" data-mp="2k6ri11vs3hjg">
                  Read our latest insights on finding your first customers and
                  building repeatable sales motions.
                </p>
              </div>
              <a href="/insights" className="bg-red-600 hover:bg-red-700 text-white font-semibold py-4 px-10 rounded-lg transition-all hover:shadow-xl hover:shadow-red-600/20 whitespace-nowrap flex items-center" data-id="element-307" data-mp="18snry6sbadjo">
                View Insights
                <svg className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-308" data-mp="2tzgc61i7bhht">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-309" data-mp="2k10j3szm5y5o" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
};